import infographic2 from '../infografika_johnnybros_2.png';

export default function Help() {

    return (
        <>
        <h1 className="title">Pomoc</h1>
        <img src={infographic2} alt="Grafika pomocy 2"/>
        </>
    );
}